import { difference, isEmpty, union } from "lodash";
import { Component, h } from "preact";
import { fromStyleLocals } from "../../utils/css";
import style = require("./SelectPicker.less");
const css = fromStyleLocals(style.locals);

// tslint:disable-next-line:interface-name
interface Props {
  getItems: () => Promise<string[]>;
  onChange: (tags: string[]) => void;
  tags: string[];
}

// tslint:disable-next-line:interface-name
interface State {
  allTags: string[];
  dataChanged: boolean;
  filterText: string;
  showResult: boolean;
  tags: string[];
  isFetching: boolean;
}
export class SelectPicker extends Component<Props, State> {
  public componentWillMount() {
    document.addEventListener("mousedown", this.outsideClick);
    const tags = this.props.tags ? this.props.tags : [];
    this.resetState(tags);
    this.props.onChange(tags);
  }

  public componentWillReceiveProps(nextProps: any) {
    const tags = nextProps.tags ? nextProps.tags : [];
    this.resetState(tags);
  }

  public componentWillUnmount() {
    document.removeEventListener("mousedown", this.outsideClick);
  }

  public renderSelector() {
    return (
      <div class={css("multi-select")} onClick={() => this.toggleOptions()}>
        <ul>
          {this.state.tags.length > 0 ? (
            <li class={css("tag")} onClick={(e: any) => e.stopPropagation()}>
              <span class={css("label")}>
                <span class={css("ellipsis")}>
                  {this.state.tags.length === 1
                    ? this.state.tags[0]
                    : this.state.tags.length + " selected"}
                </span>
                <i
                  onClick={() => this.removeAll()}
                  class={css("fa", "fa-close")}
                />
              </span>
            </li>
          ) : (
            this.state.tags.map(tag => (
              <li class={css("tag")} onClick={(e: any) => e.stopPropagation()}>
                <span class={css("label")}>
                  <span class={css("ellipsis")}>{tag}</span>
                  <i
                    onClick={() => this.onRemove(tag)}
                    class={css("fa", "fa-close")}
                  />
                </span>
              </li>
            ))
          )}
          <li class={css("handle")}>
            <i
              style="cursor: pointer;"
              class={
                this.state.showResult && this.state.dataChanged
                  ? css("fa", "fa-floppy-o")
                  : css("fa", "fa-angle-down")
              }
            />
          </li>
        </ul>
      </div>
    );
  }

  public renderSelectorOptions() {
    return (
      <div>
        <div
          class="form-group has-feedback"
          style="margin-bottom: 0px; z-index: 1000;"
        >
          <input
            type="text"
            name="filterItem"
            class="form-control"
            id="filterItem"
            placeholder="Search"
            value={this.state.filterText}
            onInput={this.setFilter.bind(this)}
          />
          <span
            style="line-height: 34px"
            class="fa fa-search form-control-feedback"
            aria-hidden="true"
          />
        </div>
        <div class={css("options")} style="overflow: auto">
          {!this.state.allTags || this.state.isFetching === true ? (
            <div style="padding-top: 8px; margin-bottom: 8px; padding-left: 10px; width:100%">
              <i class="fa fa-spinner fa-pulse fa-fw" />
              <span>Loading...</span>
            </div>
          ) : (
            <ul
              class="list-unstyled"
              style="padding-top: 8px; padding-left: 5px;"
            >
              <li>
                <div class="checkbox">
                  <label>
                    <input
                      type="checkbox"
                      checked={this.isEverythingVisibleSelected()}
                      onClick={() =>
                        this.isEverythingVisibleSelected()
                          ? this.onRemoveTags(this.getVisibleChoices())
                          : this.onAddTags(this.getVisibleChoices())
                      }
                    />
                    <span>
                      (Select all
                      {!this.state.filterText ||
                      this.state.filterText.length === 0
                        ? ""
                        : " in results"}
                      )
                    </span>
                  </label>
                </div>
              </li>
              {this.getVisibleChoices().map(item => {
                return (
                  <li>
                    <div class="checkbox">
                      <label>
                        <input
                          type="checkbox"
                          checked={this.state.tags.indexOf(item) !== -1}
                          onClick={() =>
                            this.state.tags.indexOf(item) !== -1
                              ? this.onRemove(item)
                              : this.onAdd(item)
                          }
                        />
                        <span>{item}</span>
                      </label>
                    </div>
                  </li>
                );
              })}
            </ul>
          )}
        </div>
      </div>
    );
  }

  public render() {
    if (
      this.state.showResult &&
      !this.state.allTags &&
      this.state.isFetching === false
    ) {
      this.makeApiCall();
    }
    return (
      <div class={css("generic-picker")}>
        <style>{style.toString()}</style>
        {this.renderSelector()}
        {!this.state.showResult ? (
          ""
        ) : (
          <div class={css("dropParent")}>
            {this.state.tags.length > 0 ? (
              <div
                class={css("multi-select")}
                style="border-style: none; z-index: 1000;"
              >
                <ul>
                  {this.state.tags.map(tag => (
                    <li
                      class={css("tag")}
                      onClick={(e: any) => e.stopPropagation()}
                    >
                      <span class={css("label")}>
                        <span class={css("ellipsis")}>{tag}</span>
                        <i
                          onClick={() => this.onRemove(tag)}
                          class={css("fa", "fa-close")}
                        />
                      </span>
                    </li>
                  ))}
                </ul>
              </div>
            ) : (
              ""
            )}
            {this.renderSelectorOptions()}
          </div>
        )}
      </div>
    );
  }
  private getVisibleChoices(): string[] {
    return this.state.allTags.filter(tag => {
      if (!this.state.filterText || this.state.filterText.length === 0) {
        return true;
      }
      return (
        tag
          .toLocaleLowerCase()
          .indexOf(this.state.filterText.toLocaleLowerCase()) >= 0
      );
    });
  }
  private isEverythingVisibleSelected(): boolean {
    return isEmpty(difference(this.getVisibleChoices(), this.state.tags));
  }

  private async makeApiCall() {
    this.setState({ ...this.state, isFetching: true });
    const result = await this.props.getItems().then(value => {
      this.setState({ ...this.state, isFetching: false });
      return { value };
    });
    if (result.value) {
      this.setState({ ...this.state, allTags: result.value });
    }
  }

  private setFilter(event: any) {
    this.setState({ ...this.state, filterText: event.target.value });
  }

  private updateTags(tags: string[]) {
    this.setState({ ...this.state, dataChanged: true, tags });
  }

  private onRemove(tag: string) {
    this.updateTags(this.state.tags.filter(x => x !== tag));
  }
  private onRemoveTags(tags: string[]) {
    this.updateTags(difference(this.state.tags, tags));
  }

  private removeAll() {
    this.updateTags([]);
    if (!this.state.showResult) {
      this.raiseChange();
    }
  }

  private raiseChange() {
    this.props.onChange(this.state.tags);
    this.setState({ ...this.state, dataChanged: false });
  }

  private onAdd(item: string) {
    this.updateTags(this.state.tags.concat(item));
  }
  private onAddTags(tags: string[]) {
    this.updateTags(union([...this.state.tags], [...tags]));
  }

  private toggleOptions() {
    this.setState({ ...this.state, showResult: !this.state.showResult });
    if (this.state.dataChanged) {
      this.raiseChange();
    }
  }

  private resetState(tags: string[]) {
    this.setState({ showResult: false, tags, isFetching: false });
  }

  private outsideClick(e: any) {
    if (!this.base || this.base.contains((e.path && e.path[0]) || e.target)) {
      return false;
    }
    if (this.state.showResult && this.state.dataChanged) {
      this.raiseChange();
    }
    this.setState({ ...this.state, showResult: false });
    return true;
  }
}
